var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img-card"},[_c('v-card',{staticClass:"auto-mx"},[_c('v-img',{attrs:{"src":require("../assets/me2.jpeg"),"height":"450px","width":"450px"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }